export const IS_EXIST_DIGIT = / *[0-9]/;
export const ANY_SYMBOLS = /[^A-Za-z]/;
export const IS_EXIST_UPPERCASE = /[A-Z]/;
export const IS_EXIST_LOWERCASE = /[a-z]/;
export const IS_VALID_PHONE = /[A-Za-z0-9]+$/;
export const IS_ONLY_TEXT = /^[a-zA-Z ]*$/;
export const IS_ONLY_DIGITS = /^[0-9]+$/;
export const FIND_HTML_TAGS = /<[^>]*>/;
export const FIND_BR_TAGS = /<br\s*\/?>/;
